export enum FinesAndInterests {
    Fees = 1,
    Fine = 2,
    FinesAndInterest = 3,
    None = 4,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/FinesAndInterests.enum.ts